export default "__VITE_ASSET__DY71rtph__"